import { render, staticRenderFns } from "./DropDownItem.vue?vue&type=template&id=4b048649&"
import script from "./DropDownItem.vue?vue&type=script&lang=js&"
export * from "./DropDownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports